export const MonthTypes = {
  pay_time: { label: '支付时间', color: '#E6A23C' },
  settle_time: { label: '结算时间', color: '#F56C6C' }
}
